module.exports = __webpack_public_path__ + "static/img/background7.c940312c.jpg";